import { Fragment, useEffect, useState } from 'react'

export interface FileUploaderProps {
  handleUpload: (files: File[]) => void
  multiple?: boolean
}

interface FileUploaderState {
  files?: File[]
  url?: string
}

function FileUploader(props: FileUploaderProps) {
  const [state, setState] = useState<FileUploaderState>({})

  function handleFile(event: any) {
    setState({ files: event.target.files || undefined })
  }

  useEffect(() => {
    if (!state.files) return
    props.handleUpload(state.files)
  }, [state.files, props])

  return (
    <div className="flex flex-row items-center">
      <div className="flex m-1 pb-2">
        <input id="input-file" type="file" onChange={handleFile} multiple={props.multiple} />
      </div>
    </div>
  )
}

export default FileUploader
